import React, { useState } from "react";
import axios from "axios";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send the form data to the server using Axios
    axios
      .post("https://journey-scape-main.vercel.app/api/send-email", formData)
      .then((response) => {
        console.log(response.data); // Server response
        if (response.data.message === "Email sent successfully!") {
          // Handle success here
          alert("Form submitted! You will receive an email with your details.");
        } else {
          // Handle error here
          alert("Error sending the form data. Please try again later.");
        }
      })
      .catch((error) => {
        console.error("Error sending the form data:", error);
        // Handle error here
        alert("Error submitting the form. Please try again later.");
      });
  };

  return (
    <>
      <Header />
      <div id="page" className="full-page">
        <header id="masthead" className="site-header header-primary">
          <div className="mobile-menu-container" />
        </header>
        <main id="content" className="site-main">
          {/* Inner Banner html start*/}
          <section className="inner-banner-wrap">
            <div
              className="inner-baner-container"
              style={{
                backgroundImage:
                  "url(https://res.cloudinary.com/dvop4v8kb/image/upload/e_improve,c_fill,w_1920,h_800/v1686206024/Phone_hnwoap.jpg",
              }}
            >
              <div className="container">
                <div className="inner-banner-content">
                  <h1 className="inner-title">Contact us</h1>
                </div>
              </div>
            </div>
            <div className="inner-shape" />
          </section>
          {/* Inner Banner html end*/}
          {/* contact form html start */}
          <div className="contact-page-section">
            <div className="contact-form-inner">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="contact-from-wrap">
                      <div className="section-heading">
                        <h5 className="dash-style">GET IN TOUCH</h5>
                        <h2>CONTACT US TO GET MORE INFO</h2>
                        <p>
                          Our expert team is available to provide guidance and
                          support. Contact us today and let us assist you in
                          planning your dream vacation. We're here to ensure
                          your travel experience is seamless and unforgettable.
                        </p>
                      </div>
                      <form className="contact-from" onSubmit={handleSubmit}>
                        <p>
                          <input
                            type="text"
                            name="name"
                            placeholder="Your Name*"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </p>
                        <p>
                          <input
                            type="email"
                            name="email"
                            placeholder="Your Email*"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </p>
                        <p>
                          <textarea
                            rows={8}
                            name="message"
                            placeholder="Your Message*"
                            value={formData.message}
                            onChange={handleChange}
                            required
                          />
                        </p>
                        <p>
                          <input
                            type="submit"
                            name="submit"
                            value="SUBMIT MESSAGE"
                          />
                        </p>
                      </form>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="contact-detail-wrap">
                      <h3>Need help?? Feel free to contact us!</h3>
                      <p>
                        From travel recommendations to booking assistance, we're
                        here to make your experience stress-free and enjoyable.
                        Reach out to us today and let us take care of all your
                        travel needs.
                      </p>
                      <p>
                        Don't hesitate to get in touch if you need assistance!
                        Our friendly and knowledgeable team is just a phone call
                        or email away. Feel free to contact us!
                      </p>
                      <div className="details-list">
                        <ul>
                          <li>
                            <span className="icon">
                              <i className="fas fa-map-signs" />
                            </span>
                            <div className="details-content">
                              <h4>Location Address</h4>
                              <span>Lahore</span>
                            </div>
                          </li>
                          <li>
                            <span className="icon">
                              <i className="fas fa-envelope-open-text" />
                            </span>
                            <div className="details-content">
                              <h4>Email Address</h4>
                              <a href="mailto:sameerhassan888@gmail.com">
                                sameerhassan888@gmail.com
                              </a>
                            </div>
                          </li>
                          <li>
                            <span className="icon">
                              <i className="fas fa-phone-volume" />
                            </span>
                            <div className="details-content">
                              <h4>Phone Number</h4>
                              <a href="tel:923084534190">+92 3084534190</a>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="contct-social social-links">
                        <h3>Follow us on social media..</h3>
                        <ul>
                          <li>
                            <i
                              className="fab fa-facebook-f"
                              aria-hidden="true"
                            />
                          </li>
                          <li>
                            <i className="fab fa-twitter" aria-hidden="true" />
                          </li>
                          <li>
                            <i
                              className="fab fa-instagram"
                              aria-hidden="true"
                            />
                          </li>
                          <li>
                            <i className="fab fa-linkedin" aria-hidden="true" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="map-section">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6976289.909483047!2d68.11393675050242!3d31.37576528189465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38db52d2f8fd751f%3A0x46b7a1f7e614925c!2sPakistan!5e0!3m2!1sen!2s!4v1685994872501!5m2!1sen!2s"
                width={600}
                height={450}
                style={{ border: 0 }}
                allowFullScreen=""
                title="Embedded Map"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
          {/* contact form html end */}
        </main>
      </div>
      <Footer />
    </>
  );
}
